import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { IEvacuationAggregate } from 'src/app/models/evacuation-aggregate.interface';

@Component({
  selector: 'app-evacuation-list-table',
  templateUrl: './evacuation-list-table.component.html',
  styleUrls: ['./evacuation-list-table.component.scss'],
})
export class EvacuationListTableComponent implements OnInit {
  @Input() policies: IEvacuationAggregate[];
  filteredRows: IEvacuationAggregate[];
  selectedRecord: IEvacuationAggregate;
  tableFiltersFormGroup: FormGroup;
  @Input() dataLoaded: boolean;

  constructor(private formBuilder: FormBuilder, private router: Router) {
    this.tableFiltersFormGroup = this.formBuilder.group({
      searchFilter: '',
    });
    this.filterSearchTable();
  }

  ngOnInit(): void {}

  filterSearchTable() {
    this.tableFiltersFormGroup
      .get('searchFilter')
      .valueChanges.subscribe((val) => {
        this.filteredRows = this.policies.filter((record) => {
          return Object.keys(record).reduce((acc, curr) => {
            return (
              acc ||
              JSON.stringify(record[curr])
                .toLowerCase()
                .includes(val.toLowerCase())
            );
          }, false);
        });
      });
  }

  goToPolicyDetails(_id: string) {
    this.router.navigate(['/evacuation/list/evacuation-details', _id]);
  }

  highlightCancelledPolicies(policy: any) {
    if (policy.hasOwnProperty('cancellation')) {
      return {
        'background-color': '#DB3A34',
        color: '#fff',
      };
    }
  }
}
